import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { SarlaftStateCaseProps } from './props';
import { SarlaftStateCase } from '../../../../../../shared/types/modules/sarlaft';
import {
    asyncGetParamById,
    asyncGetParams,
} from '../../../../../../services/param.service';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';

export const useSarlaftStateCase = ({
    data,
    onChangeData,
    onChangeFormik,
}: SarlaftStateCaseProps) => {
    const [status, setStatus] = useState<ISelect[]>([]);
    const [isUnusualOperation, setIsUnusualOperation] =
        useState<boolean>(false);

    const onSubmit = (data: SarlaftStateCase) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('caseStatus', data?.caseStatus || '');
        formik?.setFieldValue('observation', data?.observation || '');
    }, [data]);

    useEffect(() => {
        asyncGetParams(ParamEnum.SARLAFT_STATUS).then((items) =>
            setStatus(items)
        );
    }, []);

    useEffect(() => {
        if (formik.values.caseStatus)
            asyncGetParamById(formik.values.caseStatus).then((items) => {
                setIsUnusualOperation(
                    items?.code === `${ParamEnum.SARLAFT_STATUS}_UNUSUAL`
                );
            });
    }, [formik.values.caseStatus]);

    const handleClose = () => setIsUnusualOperation(false);

    return {
        formik,
        status,
        isUnusualOperation,
        handleClose,
    };
};
